import * as moment from 'moment';

export class EULA {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.datePublished = json && json.date_published || null;
        this.text = json && json.text || null;

        if(this.datePublished) {
            this.momentDatePublished = moment(this.datePublished);
        }
    }

    id: number;
    datePublished: string;
    text: string;

    momentDatePublished: moment.Moment;
}
